import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from 'firebase/app-check'
import env from './../environments/environment'

const firebaseApp = initializeApp(env.integrations.firebase.config)

export const firebaseAuth = getAuth(firebaseApp)

// App Check (reCAPTCHA v3) — attest requests come from the genuine app. No-op until a site key is configured.
const appCheckCfg = (env.integrations.firebase && env.integrations.firebase.appCheck) || {}

// Build id (main bundle hash) — stamped on every API request so the backend can attribute
// App Check misses to stale/old cached bundles (which lack this) vs the current build.
const APP_BUILD = (() => {
  try {
    const s = document.querySelector('script[src*="/static/js/main."]')
    const m = s && s.src && s.src.match(/main\.([\w-]+)\.js/)
    return m ? m[1] : 'dev'
  } catch (e) {
    return 'unknown'
  }
})()

let appCheckInstance = null

if (appCheckCfg.recaptchaSiteKey) {
  if (appCheckCfg.debugToken) window.FIREBASE_APPCHECK_DEBUG_TOKEN = appCheckCfg.debugToken

  appCheckInstance = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(appCheckCfg.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  })

  // Pre-warm the first token at load so early bootstrap calls (system_settings,
  // change_logs, user_notes) don't race reCAPTCHA readiness → "missing token".
  getToken(appCheckInstance).catch(() => {})
}

// Attach the X-Firebase-AppCheck header to an axios instance (no-op if App Check is inactive).
export const attachAppCheck = instance => {
  instance.interceptors.request.use(async config => {
    config.headers['X-App-Version'] = APP_BUILD
    if (appCheckInstance) {
      const setToken = t => {
        if (t) config.headers['X-Firebase-AppCheck'] = t
        return !!t
      }
      try {
        const { token } = await getToken(appCheckInstance)
        if (!setToken(token)) throw new Error('empty App Check token')
      } catch (e) {
        // One force-refresh retry recovers a stale/expiring cached token (the
        // "expired" warnings) and a first-call race before reCAPTCHA is ready.
        try {
          const { token } = await getToken(appCheckInstance, true)
          setToken(token)
        } catch (e2) {
          // Still failing — monitor mode proceeds without a token, but the cause
          // is no longer invisible (browser console / telemetry).
          console.warn('[AppCheck] getToken failed:', (e2 && e2.message) || e2)
        }
      }
    }

    return config
  })

  return instance
}

export default firebaseApp
